import { Modal as BaseModal, ModalFooter, ModalButton } from 'baseui/modal';
import * as React from 'react';
type PropsT = {
  modalState: any;
  type: string;
  setModal: Function;
  onConfirm: Function;
  children?: React.ReactNode | null;
};
export default class Modal extends React.PureComponent<PropsT> {
  render() {
    const {
      modalState,
      type,
      setModal,
      children,
      onConfirm
    } = this.props;
    return <BaseModal onClose={() => {
      setModal(type, {
        open: false
      });
    }} isOpen={modalState.open || false}>
        {children}
        <ModalFooter>
          <ModalButton onClick={() => {
          setModal(type, {
            open: false
          });
        }}>
            Cancel
          </ModalButton>
          <ModalButton onClick={() => {
          onConfirm(modalState);
        }}>
            Copy
          </ModalButton>
        </ModalFooter>
      </BaseModal>;
  }
}